import dayjs from 'dayjs'
import { FormattedReviewsList } from 'ui'

export type ProductReviewsResponse = {
  stats: {
    average: string
    count: number
  }
  reviews: {
    data: Array<{
      title: string
      review: string
      rating: number
      date_created: string
      reviewer: {
        first_name: string
        last_name: string
        verified_buyer: string
        address: string
      }
    }>
  }
}

const capitalize = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const formatReviewDate = (date: string, locale: string): string => {
  const dateAgoFormat = new Intl.RelativeTimeFormat(locale, { style: 'long' })
  const reviewDate = dayjs(date)
  const today = dayjs()

  if (reviewDate.diff(today, 'year') > -1) {
    if (reviewDate.diff(today, 'months') > -1) {
      if (reviewDate.diff(today, 'weeks') > -1) {
        if (reviewDate.diff(today, 'days') > -1) {
          return dateAgoFormat.format(reviewDate.diff(today, 'hour'), 'hour')
        }

        return dateAgoFormat.format(reviewDate.diff(today, 'day'), 'day')
      }

      return dateAgoFormat.format(reviewDate.diff(today, 'week'), 'week')
    }

    return dateAgoFormat.format(reviewDate.diff(today, 'month'), 'month')
  }

  return new Date(date).toLocaleDateString('de')
}

export const formatReviews = (
  reviews: ProductReviewsResponse,
  locale: string,
): FormattedReviewsList => {
  return {
    ratings: {
      reviewsCount: reviews.stats.count,
      reviewsScore: parseFloat(parseFloat(reviews.stats.average).toFixed(1)),
    },
    reviews: reviews.reviews.data.map(review => ({
      title: review.title,
      text: review.review,
      rating: review.rating,
      firstName: review.reviewer.first_name,
      lastName: review.reviewer.last_name,
      address: review.reviewer.address,
      timeAgo: capitalize(formatReviewDate(review.date_created, locale)),
      verifiedBuyer: review.reviewer.verified_buyer === 'yes',
    })),
  }
}
